"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//
// assets
//
const queryDefinitions_1 = require("queryDefinitions");
const tokenHeader_1 = require("tokenHeader");
const accountCopy_1 = require("copy/accountCopy");
//
// styles
//
const StyledBillingTabLink_1 = require("./StyledBillingTabLink");
const StyledIcon_1 = require("./StyledIcon");
const withAccount_1 = require("components/withAccount");
const useAccountChange_1 = __importDefault(require("components/useAccountChange"));
const BillingTabLink = () => {
    const [url, setUrl] = (0, react_1.useState)();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type '((optio... Remove this comment to see the full error message
    const [getBillingPage, { loading, error, data }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_BILLING_PAGE);
    (0, useAccountChange_1.default)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getBillingPage({ variables: {} });
    });
    (0, react_1.useEffect)(() => {
        var _a;
        if (!loading && !error && ((_a = data === null || data === void 0 ? void 0 : data.billingPage) === null || _a === void 0 ? void 0 : _a.url)) {
            setUrl(data.billingPage.url);
        }
    }, [loading, data]);
    return !error ? (react_1.default.createElement(StyledBillingTabLink_1.StyledBillingTabLink, { href: url, target: '_blank' },
        loading && !url ? 'Loading...' : accountCopy_1.accountCopy.tab2,
        react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-external-link' }))) : null;
};
exports.default = (0, withAccount_1.withAccount)(BillingTabLink);
